import {RouteEnum} from "@/router/RouteEnum.ts";
import FusionView from "@/views/FusionView.vue";
import SynchronizationStepper from "@/components/SynchronizationStepper.vue";
import type {RouteLocation} from "vue-router";
import {SynchroType} from "@/domain/type/synchro.type.ts";
import CompanyUsersView from "@/views/CompanyUsersView.vue";

const fusionCompany = {
  path: '/synchro/:sourceLeft/:sourceRight/:id',
  name: RouteEnum.FusionCompany,
  redirect: (to: RouteLocation) => {
    return {
      name: RouteEnum.Fusion,
      params: {
        sourceLeft: to.params.sourceLeft,
        sourceRight: to.params.sourceRight,
        id: to.params.id,
        type: SynchroType.COMPANIES
      }
    }
  }
}
const fusion = {
  path: '/synchro/:sourceLeft/:sourceRight/:id/:type',
  name: RouteEnum.Fusion,
  components: {
    default: FusionView,
    headerCenter: SynchronizationStepper
  },
  props: true,
}
const fusionUserFromCompany = {
  path: '/synchro/:sourceLeft/:sourceRight/:ownerId/:id/:type',
  name: RouteEnum.FusionFromOwner,
  components: {
    default: FusionView,
    headerCenter: SynchronizationStepper
  },
  props: true,
}
const companyUsers = {
  path: '/company/:siret/users',
  name: RouteEnum.CompanyUsers,
  components: {
    default: CompanyUsersView,
    headerCenter: SynchronizationStepper
  },
  props: true,
}
const fusionRoutes = [
  fusionCompany,
  fusion,
  fusionUserFromCompany,
  companyUsers,
]

export default fusionRoutes
